import classNames from 'classnames';
import { isArray } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useMyRFQs } from '@steelbuy/data-access';
import { TranslateFunc } from '@steelbuy/ts-shared';
import {
    BadgeState,
    BadgeVariant,
    ButtonTertiaryOnLightM,
    DataHeader,
    LoadingSpinner,
    LoadingStatus,
} from '@steelbuy/ui-primitive';

import { myRfqsTableHeading, quoteTableConfig } from './requestQuoteTableUtils';

import './MyRequestQuotesTable.scss';
import { MyRFQsEmptyState } from '../my-rfqs/MyRFQsEmptyState';

const MY_RFQS_PAGE_SIZE = 15;

export const MyRequestQuotesTable = () => {
    const { t } = useTranslation(['translation', 'domainModel', 'uiDomain']);
    const { isLoading, total, hasNextPage, isFetchingNextPage, fetchNextPage, data } = useMyRFQs({
        pageSize: MY_RFQS_PAGE_SIZE,
    });

    return (
        <div className="quotes">
            {isLoading ? (
                <LoadingSpinner fillContainerHeight />
            ) : (
                <div className={classNames('quotes-table', { 'quotes-table--loading': isLoading })}>
                    <DataHeader
                        headingValue={t('application.myRFQ.numberOfRFQListings', {
                            count: total ?? 0,
                        })}
                    />
                    {total && total > 0 ? (
                        <div className="table-wrapper">
                            <div className="table-container">
                                <table>
                                    <thead>
                                        <tr>
                                            {myRfqsTableHeading.map((heading) => (
                                                <th key={heading}>
                                                    <div className="table-heading">
                                                        <span>
                                                            {quoteTableConfig[heading]?.getHeading(t as TranslateFunc)}
                                                        </span>
                                                    </div>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((quote) => (
                                            <tr key={quote.id}>
                                                {myRfqsTableHeading.map((heading) => {
                                                    const value = quoteTableConfig[heading]?.mapValue?.(
                                                        quote,
                                                        t as TranslateFunc
                                                    );

                                                    const renderCellContent = () => {
                                                        if (isArray(value)) {
                                                            return value?.map((text) => <div key={text}>{text}</div>);
                                                        }
                                                        if (heading === 'rfqStatus') {
                                                            return (
                                                                <BadgeState
                                                                    label={value as string}
                                                                    variant={BadgeVariant.NEUTRAL}
                                                                />
                                                            );
                                                        }
                                                        return value;
                                                    };

                                                    return <td key={heading}>{renderCellContent()}</td>;
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : null}
                    {hasNextPage && (
                        <div className="quotes-table__load-more">
                            <ButtonTertiaryOnLightM
                                onClick={() => fetchNextPage()}
                                label={t('uiDomain:commonList.loadMore')}
                                loadingStatus={isFetchingNextPage ? LoadingStatus.PENDING : LoadingStatus.IDLE}
                            />
                        </div>
                    )}
                    {data?.length === 0 && <MyRFQsEmptyState />}
                </div>
            )}
        </div>
    );
};
